import PhysicianReviewPage from "./PhysicianReviewPage";

export default PhysicianReviewPage;
